import React, { useState } from 'react';
import { Box, Flex } from '@rebass/emotion';
import { FormattedMessage } from 'react-intl';
import RouteProps from '../RoutesWithLayout/RouteProps';
import LanguageProvider from '../../providers/LanguageProvider';
import Link from '../Link';
import styles from './LanguageSuggestPopup.styles';
import messages from './LanguageSuggestPopup.messages';

export interface LanguageSuggestPopupProps extends RouteProps {
  preferredLanguage: string;
  onClose?: () => void;
}

const LanguageSuggestPopup = ({
  preferredLanguage,
  onClose = () => {},
  match,
}: LanguageSuggestPopupProps): JSX.Element | null => {
  const [show, setShow] = useState(true);

  if (!show) {
    return null;
  }

  const closePopUp = (): void => {
    setShow(false);
    onClose();
  };

  return (
    <LanguageProvider
      locale={preferredLanguage}
      keys={[
        'components.languageSuggest.head',
        'components.languageSuggest.body',
        'components.languageSuggest.linkText',
      ]}
    >
      <Box css={styles.popupStyles} p={2}>
        <Flex justifyContent="space-between">
          <h3 css={styles.popupHeadTextStyles}>
            <FormattedMessage {...messages.head} />
          </h3>
          <button css={styles.closeButtonStyles} onClick={closePopUp}>
            <svg
              height="15"
              viewBox="0 0 15 15"
              width="15"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="m1.42857143.70710678-.72146465.72146465 6.07142857 6.07142857-6.07142857 6.0714286.72146465.7214646 6.07142857-6.07142855 6.0714286 6.07142855.7214646-.7214646-6.07142855-6.0714286 6.07142855-6.07142857-.7214646-.72146465-6.0714286 6.07142857z"
                fill="currentColor"
              />
            </svg>
          </button>
        </Flex>

        <Flex css={styles.popupBodyStyles} py={3}>
          <FormattedMessage {...messages.body} />
        </Flex>
        <Flex>
          <Link
            css={styles.popupLinkStyles}
            to={match.path}
            params={{
              url: match.params.url,
              language: preferredLanguage,
            }}
            onClick={closePopUp}
          >
            <FormattedMessage {...messages.linkText} />
          </Link>
        </Flex>
      </Box>
    </LanguageProvider>
  );
};

export default LanguageSuggestPopup;
